'use strict';

angular.module('mean.foreman').factory('Foreman', [
  function() {
    return {
      name: 'foreman'
    };
  }
]);

angular.module('mean.foreman').filter('percentage', ['$filter', function ($filter) {
  return function (input, decimals) {
    return $filter('number')(input * 100, decimals) + '%';
  };
}]);


// WEBPACK FOOTER //
// ./packages/custom/foreman/public/services/foreman.js